import React from "react";
import { Wrapper, StyledTip, TipText } from "./style";

const Tip = ({ text, iconSize = 60 }) => (
  <Wrapper>
    <StyledTip width={iconSize} height={iconSize} />
    <TipText>{text}</TipText>
  </Wrapper>
);

export default Tip;



// WEBPACK FOOTER //
// ./src/components/tip/index.js